/**
 * Состав пака «warm-cream» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 14 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 4 из 14 воронок: palette → ближайшая тема по цветам
    { themeId: 'bento-brutalist', weight: 0.29 },
    // 3 из 14 воронок: palette → ближайшая тема по цветам
    { themeId: 'study-blue', weight: 0.21 },
  ],
  fonts: [
    // 8 из 14 воронок: fontId
    { fontId: 'inter', weight: 0.57 },
    // 3 из 14 воронок: fontId
    { fontId: 'poppins', weight: 0.21 },
    // 2 из 14 воронок: fontId
    { fontId: 'manrope', weight: 0.14 },
  ],
  screenKinds: [
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.287; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.3 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.262
    { kind: 'N4', share: 0.27 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.158
    { kind: 'N2', share: 0.17 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.085
    { kind: 'N8', share: 0.09 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.053
    { kind: 'I1', share: 0.06 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.038
    { kind: 'N5', share: 0.04 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.035
    { kind: 'N1', share: 0.04 },
    // средняя доля экранов по 14 воронкам (признаки.json kinds) 0.035
    { kind: 'N6', share: 0.04 },
  ],
  blocks: [
    // в 10 из 14 воронок (признаки.json blocks), подъём 1.04; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 94 из 115, optionIndicator 109 из 115, optionIconPosition 75 из 115
    {
      type: 'single_choice',
      weight: 0.71,
      settings: {
        autoAdvance: true,
        optionIndicator: 'none',
        optionIconPosition: 'left',
      },
    },
    // в 7 из 14 воронок (признаки.json blocks), подъём 1.11; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 26 из 36
    {
      type: 'multiple_choice',
      weight: 0.5,
      settings: { optionIndicator: 'none' },
    },
    // в 6 из 14 воронок (признаки.json blocks), подъём 3.00; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): testimonialQuoteMarks 8 из 12, testimonialPhotoLayout 6 из 12
    {
      type: 'testimonials',
      weight: 0.43,
      settings: {
        testimonialQuoteMarks: false,
        testimonialPhotoLayout: 'avatar',
      },
    },
    // в 8 из 14 воронок (признаки.json blocks), подъём 1.19
    { type: 'loader_processing', weight: 0.57, settings: {} },
    // в 5 из 14 воронок (признаки.json blocks), подъём 1.23
    { type: 'text_field', weight: 0.36, settings: {} },
    // в 3 из 14 воронок (признаки.json blocks), подъём 1.31
    { type: 'name_field', weight: 0.21, settings: {} },
  ],
  niches: [
    // 3 из 14 воронок (признаки.json theme)
    { niche: 'beauty', weight: 0.21 },
    // 2 из 14 воронок (признаки.json theme)
    { niche: 'health', weight: 0.14 },
    // 2 из 14 воронок (признаки.json theme)
    { niche: 'mental_health', weight: 0.14 },
    // 2 из 14 воронок (признаки.json theme)
    { niche: 'general', weight: 0.14 },
  ],
};
